import {MessageBaseView} from "../../MessageModel/view/MessageBaseView";

export class MemberForSalesSuppliersListView {
    id: number;
    status: number;
    companyName: string;
    expertRole: ExpertRoleView;
    dateLastStatusChange: Date | null;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.status = data?.status ?? 0;
        this.companyName = data?.companyName ?? '';
        this.expertRole = data?.expertRole ? new ExpertRoleView(data.expertRole) : new ExpertRoleView();
        this.dateLastStatusChange = data?.dateLastStatusChange ? new Date(data.dateLastStatusChange) : null;
    }
}

class ExpertRoleView {
    id: number;
    expertBusinessTypes: ExpertBusinessTypeView[];
    partnerSubmissionLastMonth: number;
    invoiceAcctLinesAmountLastMonth: number;
    invoiceAcctLinesAmountMonthMinus2: number;
    invoiceAcctLinesAmountMonthMinus3: number;
    invoiceAcctLinesAmountMonthMinus4: number;
    expertRegistrationDate: Date | null;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.expertBusinessTypes = data?.expertBusinessTypes ? data.expertBusinessTypes.map((item: any) => new ExpertBusinessTypeView(item)) : [];
        this.partnerSubmissionLastMonth = data?.partnerSubmissionLastMonth ?? 0;
        this.invoiceAcctLinesAmountLastMonth = data?.invoiceAcctLinesAmountLastMonth ?? 0;
        this.invoiceAcctLinesAmountMonthMinus4 = data?.invoiceAcctLinesAmountMonthMinus4 ?? 0;
        this.invoiceAcctLinesAmountMonthMinus3 = data?.invoiceAcctLinesAmountMonthMinus3 ?? 0;
        this.invoiceAcctLinesAmountMonthMinus2 = data?.invoiceAcctLinesAmountMonthMinus2 ?? 0;
        this.expertRegistrationDate = data?.expertRegistrationDate ? new Date(data.expertRegistrationDate) : null;
    }
}

class ExpertBusinessTypeView {
    id: number;
    businessTypeModel: BusinessTypeView;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.businessTypeModel = data?.businessTypeModel ? new BusinessTypeView(data.businessTypeModel) : new BusinessTypeView();
    }
}

class BusinessTypeView {
    id: number;
    translatedName: MessageBaseView;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.translatedName = data?.translatedName ? new MessageBaseView(data.translatedName) : new MessageBaseView();
    }
}